(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rp2-system"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rp2-gallery')) customElements.define('rp2-gallery', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.stage = this.querySelector('.rp2-gallery__stage');
    this.frames = Array.from(this.querySelectorAll('[data-frame]'));
    this.buttons = Array.from(this.querySelectorAll('[data-slide]'));
    this.counter = this.querySelector('[data-gallery-count]');
    this.current = 0;
    if (!this.stage || !this.frames.length) return;
    this.addEventListener('click', event => {
      const step = event.target.closest('[data-gallery-step]');
      if (step) { this.goTo(this.current + Number(step.dataset.galleryStep)); return; }
      const button = event.target.closest('[data-slide]');
      if (!button) return;
      const index = this.frames.findIndex(frame => frame.dataset.frame === button.dataset.slide);
      this.goTo(index);
    });
    this.stage.addEventListener('scroll', () => this.sync(), { passive: true });
    this.stage.addEventListener('keydown', event => {
      if (event.target !== this.stage) return;
      let next;
      if (event.key === 'ArrowRight') next = this.current + 1;
      else if (event.key === 'ArrowLeft') next = this.current - 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = this.frames.length - 1;
      else return;
      event.preventDefault();
      this.goTo(next);
    });
    this.sync();
    this.stageWidth = this.stage.clientWidth;
    this.resize = new ResizeObserver(() => {
      const width = this.stage.clientWidth;
      if (width !== this.stageWidth) {
        this.stageWidth = width;
        this.goTo(this.current, false);
      }
      this.fitActiveFrame();
    });
    this.resize.observe(this.stage);
    if (this.hasAttribute('data-story-gallery')) this.frames.forEach(frame => this.resize.observe(frame));
  }
  goTo(index, animate = true) {
    const next = Math.max(0, Math.min(this.frames.length - 1, index));
    const smooth = animate && !matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.stage.scrollTo({ left: next * this.stage.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
  }
  sync() {
    if (!this.stage.clientWidth) return;
    if (this.stageWidth && this.stage.clientWidth !== this.stageWidth) return;
    const previous = this.current;
    this.current = Math.max(0, Math.min(this.frames.length - 1, Math.round(this.stage.scrollLeft / this.stage.clientWidth)));
    this.frames.forEach((frame, index) => {
      const active = index === this.current;
      frame.setAttribute('aria-hidden', String(!active));
      frame.inert = !active;
      if (!active) frame.querySelectorAll('video').forEach(video => video.pause());
    });
    this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.slide === this.frames[this.current].dataset.frame)));
    if (this.counter) this.counter.textContent = (this.current + 1) + ' / ' + this.frames.length;
    this.querySelectorAll('[data-gallery-step]').forEach(button => {
      button.disabled = Number(button.dataset.galleryStep) < 0 ? this.current === 0 : this.current === this.frames.length - 1;
    });
    if (previous !== this.current) {
      const activeButton = this.buttons.find(button => button.dataset.slide === this.frames[this.current].dataset.frame);
      const strip = activeButton?.parentElement;
      if (strip && strip.scrollWidth > strip.clientWidth) {
        const buttonRect = activeButton.getBoundingClientRect();
        const stripRect = strip.getBoundingClientRect();
        strip.scrollBy({ left: buttonRect.left - stripRect.left - (strip.clientWidth - buttonRect.width) / 2, behavior: 'auto' });
      }
    }
    this.fitActiveFrame();
  }
  fitActiveFrame() {
    if (!this.hasAttribute('data-story-gallery')) return;
    const height = Math.ceil(this.frames[this.current].getBoundingClientRect().height);
    if (height > 0 && this.stage.style.height !== height + 'px') this.stage.style.height = height + 'px';
  }
  disconnectedCallback() {
    if (this.resize) this.resize.disconnect();
  }
});
if(!customElements.get('rp2-calculator'))customElements.define('rp2-calculator',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const input=this.querySelector('input'),out=this.querySelector('output'),bar=this.querySelector('[data-protection-bar]');const price=Number(this.dataset.price);const update=()=>{const quote=Number(input.value);if(!Number.isFinite(quote)||quote<=0){out.textContent=this.dataset.empty;bar.style.width='0%';return;}const ratio=Math.round(price/quote*1000)/10;out.textContent=this.dataset.result.replace('[percent]',new Intl.NumberFormat(document.documentElement.lang,{maximumFractionDigits:1}).format(ratio));bar.style.width=Math.min(100,Math.max(2,ratio))+'%';};input.addEventListener('input',update);update();}});
if(!customElements.get('rp2-product'))customElements.define('rp2-product',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const select=this.querySelector('select[name=id]');const button=this.querySelector('[data-purchase]');const sticky=this.querySelector('.rp2-sticky');if(select)select.addEventListener('change',()=>{const o=select.selectedOptions[0];this.querySelectorAll('[data-current-price]').forEach(p=>p.textContent=o.dataset.price);this.querySelectorAll('[data-purchase]').forEach(b=>{b.disabled=o.dataset.available!=='true';b.querySelector('[data-label]').textContent=b.disabled?this.dataset.sold:this.dataset.action;});const u=new URL(location.href);u.searchParams.set('variant',o.value);history.replaceState(null,'',u);});if(button&&sticky){this.observer=new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting},{threshold:0});this.observer.observe(button);}}disconnectedCallback(){if(this.observer)this.observer.disconnect();}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rv-door-bundles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rv-door-bundles')) {
  customElements.define('rv-door-bundles', class extends HTMLElement {
    connectedCallback() {
      if (this.listeners) return;
      this.listeners = new AbortController();
      queueMicrotask(() => {
        if (!this.isConnected) return;
        this.product = this.closest('rp2-product');
        this.form = this.closest('form');
        this.quantity = this.form?.querySelector('input[name="quantity"]');
        this.options = [...this.querySelectorAll('[data-bundle-option]')];
        if (!this.product || !this.quantity || this.options.length !== 3) return;
        const events = { signal: this.listeners.signal };
        this.options.forEach(option => option.addEventListener('change', () => {
          if (!option.checked) return;
          this.quantity.value = option.value;
          this.quantity.dispatchEvent(new Event('input', { bubbles: true }));
          this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
          this.sync(true);
        }, events));
        this.quantity.addEventListener('input', () => this.sync(false), events);
        this.quantity.addEventListener('change', () => this.sync(true), events);
        this.form.querySelector('select[name="id"]')?.addEventListener('change', () => queueMicrotask(() => this.sync(false)), events);
        this.form.addEventListener('reset', () => queueMicrotask(() => this.sync(false)), events);
        window.addEventListener('pageshow', () => this.sync(false), events);
        this.product.setAttribute('data-door-bundles-ready', '');
        this.hidden = false;
        this.sync(false);
      });
    }
    sync(announce) {
      const quantity = Number(this.quantity.value);
      if (!Number.isSafeInteger(quantity) || quantity < 1) return;
      const option = this.options.find(item => Number(item.value) === quantity);
      this.options.forEach(item => { item.checked = item === option; });
      const discount = quantity >= 3 ? 3800 : quantity === 2 ? 1900 : 0;
      const total = option ? option.dataset.total : new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: 'USD' }).format((9900 * quantity - discount) / 100) + ' USD';
      const count = option ? option.dataset.count : this.dataset.countPattern.replace('__QUANTITY__', String(quantity));
      const action = option ? option.dataset.button : this.dataset.buttonPattern.replace('__QUANTITY__', String(quantity));
      this.product.querySelectorAll('[data-current-price]').forEach(price => { price.textContent = total; });
      this.product.querySelectorAll('[data-bundle-count]').forEach(label => { label.textContent = count; });
      this.product.querySelectorAll('[data-bundle-total-label]').forEach(label => { label.hidden = quantity === 1; });
      this.product.querySelectorAll('[data-purchase]').forEach(button => {
        const label = button.querySelector('[data-label]');
        if (label && !button.disabled) label.textContent = action;
      });
      if (announce) this.querySelector('[data-bundle-announcement]').textContent = this.dataset.announcementPattern.replace('__COUNT__', count).replace('__TOTAL__', total);
    }
    disconnectedCallback() {
      this.listeners?.abort();
      this.listeners = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rv-interactions"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('rv-evidence')) customElements.define('rv-evidence',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.dialog=this.querySelector('dialog');this.addEventListener('click',e=>{const view=e.target.closest('[data-evidence-view]');if(view){this.querySelector('[data-evidence-window]').dataset.view=view.dataset.evidenceView;this.querySelectorAll('[data-evidence-view]').forEach(b=>b.setAttribute('aria-pressed',String(b===view)));}if(e.target.closest('[data-open-original]'))this.dialog.showModal();if(e.target.closest('[data-close-original]')||e.target===this.dialog)this.dialog.close();});}
});
document.addEventListener('click',e=>{document.querySelectorAll('.rv-mobile-menu[open]').forEach(menu=>{if(!menu.contains(e.target)||e.target.closest('a'))menu.open=false;});});
document.addEventListener('keydown',e=>{if(e.key==='Escape')document.querySelectorAll('.rv-mobile-menu[open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});

(() => {
  if (window.RollProofMotion) {
    window.RollProofMotion.refresh(document);
    return;
  }

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const canObserve = 'IntersectionObserver' in window;
  const canAnimate = typeof Element.prototype.animate === 'function';
  const registered = new WeakSet();
  const records = new Set();
  const recordByAnchor = new WeakMap();
  const active = new Map();
  const videoStates = new Set();
  const videoByElement = new WeakMap();
  const ease = 'cubic-bezier(.22,.68,.18,1)';
  let entranceObserver;
  let videoObserver;
  let videoLoadObserver;

  function find(scope, selector) {
    const found = [...scope.querySelectorAll(selector)];
    if (scope instanceof Element && scope.matches(selector)) found.unshift(scope);
    return found;
  }

  function complete(record) {
    record.done = true;
    entranceObserver?.unobserve(record.anchor);
    record.targets.forEach(target => {
      target.element.dataset.rvEntered = 'true';
    });
  }

  function playEntrance(record) {
    if (record.done) return;
    complete(record);
    if (reduced.matches || !canAnimate || document.hidden) return;
    record.targets.forEach(({ element, delay = 0, kind = 'copy' }) => {
      if (!element.isConnected || kind === 'signal') return;
      const photo = kind === 'photo';
      const support = kind === 'support';
      const startOpacity = photo ? .94 : support ? 1 : .88;
      const distance = photo ? 10 : support ? 7 : 9;
      element.dataset.rvMotionActive = 'true';
      const animation = element.animate([
        { opacity: startOpacity, transform: `translate3d(0,${distance}px,0)` },
        { opacity: 1, transform: 'translate3d(0,0,0)' }
      ], { duration: photo ? 720 : 520, delay, easing: ease, fill: 'backwards', iterations: 1 });
      active.set(animation, element);
      const release = () => {
        active.delete(animation);
        delete element.dataset.rvMotionActive;
      };
      animation.finished.then(release, release);
    });
  }

  function register(anchor, targets) {
    if (!anchor || recordByAnchor.has(anchor)) return;
    const eligible = targets.filter(target => {
      const element = target.element;
      if (!element || registered.has(element)) return false;
      if (element.matches('h1,img,a,button,input,select,textarea,form,video')) return false;
      if (element.querySelector('h1,form,button,video,iframe,img[loading="eager"],img[fetchpriority="high"]')) return false;
      registered.add(element);
      return true;
    });
    if (!eligible.length) return;
    const record = { anchor, targets: eligible, done: false };
    records.add(record);
    recordByAnchor.set(anchor, record);
    if (reduced.matches || !canObserve || !canAnimate) complete(record);
    else entranceObserver.observe(anchor);
  }

  function sequence(scope, anchors, children, kind = 'copy', stagger = 65) {
    find(scope, anchors).forEach(anchor => {
      register(anchor, [...anchor.querySelectorAll(children)].map((element, index) => ({
        element, kind, delay: Math.min(index * stagger, 180)
      })));
    });
  }

  function refreshEntrances(scope) {
    if (canObserve && !entranceObserver) {
      entranceObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) playEntrance(recordByAnchor.get(entry.target));
        });
      }, { threshold: .12, rootMargin: '0px 0px -4% 0px' });
    }
    sequence(scope, '.rv-hero-copy', ':scope > .rv-eye,:scope > .rv-lead,:scope > .rv-hero-benefits,:scope > .rv-hero-status', 'support', 55);
    sequence(scope, '.rv-product__intro,.rv-page__intro', ':scope > .rv-eye,:scope > .rv-lead', 'support', 70);
    sequence(scope, '.rv-section-heading', ':scope > div > .rv-eye,:scope > div > h2,:scope > .rv-lead');
    sequence(scope, '.rv-compare-v2__intro', ':scope > div > .rv-compare-v2__eye,:scope > div > h2,:scope > .rv-compare-v2__context > p');
    sequence(scope, '.rv-offer-intro', ':scope > .rv-eye,:scope > h2,:scope > p:not(.rv-eye)', 'copy', 60);
    sequence(scope, '.rv-offer-questions > div:first-child', ':scope > .rv-eye,:scope > h2');
    sequence(scope, '.rv-materials-explainer', ':scope > .rv-eye,:scope > h3');
    sequence(scope, '.rv-founder-grid > div', ':scope > .rv-eye,:scope > h2,:scope > .rv-lead,:scope > .rv-founder-signature');

    find(scope, '.rv-compare-v2__point').forEach(row => {
      const headings = [...row.querySelectorAll('.rv-compare-v2__point-content h4')];
      const bodies = [...row.querySelectorAll('.rv-compare-v2__point-content > p:last-child')];
      register(row, [...headings.map(element => ({ element, delay: 0 })), ...bodies.map(element => ({ element, delay: 85 }))]);
    });
    find(scope, '.rv-design-card').forEach((card, index) => {
      register(card, [
        { element: card.querySelector('.rv-design-art'), kind: 'photo', delay: index % 3 * 45 },
        { element: card.querySelector('.rv-design-caption'), delay: 90 + index % 3 * 45 }
      ]);
    });
    find(scope, '.rv-routine-benefits > article,.rv-materials-layer,.rv-offer-benefit').forEach((element, index) => {
      register(element, [{ element, delay: index % 3 * 55 }]);
    });
    find(scope, '.rv-evidence-window,.rv-founder figure,.rv-materials-photo,.rv-page__fit-photo,.rv-page__article-photo').forEach(element => {
      register(element, [{ element, kind: 'photo' }]);
    });
    find(scope, '.rv-offer-seal,.rv-layer-diagram').forEach(element => {
      register(element, [{ element, kind: 'signal' }]);
    });
    find(scope, '[data-rv-reveal]').forEach(element => {
      register(element, [{ element, kind: element.matches('figure') ? 'photo' : 'copy' }]);
    });
  }

  function finishActive(root) {
    active.forEach((element, animation) => {
      if (root && root !== element && !root.contains(element)) return;
      animation.cancel();
      active.delete(animation);
      delete element.dataset.rvMotionActive;
    });
  }

  function updateVideo(state) {
    const { video, button, player } = state;
    const ended = video.ended;
    const playing = !video.paused && !ended;
    player.dataset.rvPlayback = ended ? 'ended' : playing ? 'playing' : 'paused';
    const key = ended ? 'labelReplay' : playing ? 'labelPause' : 'labelPlay';
    const label = button?.dataset[key];
    if (label && button) {
      const text = button.querySelector('[data-rv-construction-label]') || button;
      text.textContent = label;
      button.setAttribute('aria-label', label);
      button.setAttribute('aria-pressed', String(playing));
    }
  }

  function loadVideo(state) {
    if (!state || state.loaded) return;
    state.loaded = true;
    const { video } = state;
    if (video.dataset.src) video.src = video.dataset.src;
    video.querySelectorAll('source[data-src]').forEach(source => {
      source.src = source.dataset.src;
    });
    video.preload = 'metadata';
    video.load();
    videoLoadObserver?.unobserve(video);
  }

  function mayPlayVideo(state) {
    return state.visible && !document.hidden && !state.userPaused && (!reduced.matches || state.manualPlayback);
  }

  function pauseVideo(state) {
    state.playRequest += 1;
    state.video.pause();
    updateVideo(state);
  }

  function startVideo(state, manual = false) {
    if (manual) {
      state.userPaused = false;
      state.manualPlayback = true;
    }
    if (!mayPlayVideo(state) || !state.video.paused) return;
    loadVideo(state);
    const { video } = state;
    const request = ++state.playRequest;
    if (video.ended || Number.isFinite(video.duration) && video.duration > 0 && video.currentTime >= video.duration - .05) video.currentTime = 0;
    video.play().then(() => {
      if (request !== state.playRequest) return;
      if (!mayPlayVideo(state)) pauseVideo(state);
      updateVideo(state);
    }).catch(() => updateVideo(state));
  }

  function refreshVideos(scope) {
    if (canObserve && !videoObserver) {
      videoLoadObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) loadVideo(videoByElement.get(entry.target));
        });
      }, { rootMargin: '220px 0px', threshold: 0 });
      videoObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const state = videoByElement.get(entry.target);
          if (!state) return;
          state.visible = entry.isIntersecting && entry.intersectionRatio >= .55;
          if (!state.visible) pauseVideo(state);
          else startVideo(state);
        });
      }, { threshold: [0, .3, .55, .8] });
    }
    find(scope, '[data-rv-construction-video]').forEach(video => {
      if (videoByElement.has(video)) return;
      const player = video.closest('[data-rv-construction-player]');
      if (!player) return;
      const button = player.querySelector('[data-rv-construction-toggle]');
      const controller = new AbortController();
      const state = { video, player, button, controller, loaded: false, visible: false, userPaused: false, manualPlayback: false, playRequest: 0 };
      videoByElement.set(video, state);
      videoStates.add(state);
      video.autoplay = false;
      video.removeAttribute('autoplay');
      video.loop = true;
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.controls = !button;
      player.dataset.rvVideoEnhanced = 'true';
      const options = { signal: controller.signal };
      ['play', 'pause', 'ended', 'error'].forEach(event => video.addEventListener(event, () => updateVideo(state), options));
      button?.addEventListener('click', () => {
        if (video.paused || video.ended) {
          const rect = video.getBoundingClientRect();
          state.visible = rect.bottom > 0 && rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
          startVideo(state, true);
        } else {
          state.userPaused = true;
          state.manualPlayback = false;
          pauseVideo(state);
        }
      }, options);
      updateVideo(state);
      if (canObserve) {
        videoLoadObserver.observe(video);
        videoObserver.observe(video);
      } else {
        const checkVisibility = () => {
          const rect = video.getBoundingClientRect();
          const visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
          state.visible = rect.height > 0 && visibleHeight / rect.height >= .55 && rect.right > 0 && rect.left < window.innerWidth;
          if (!state.visible) pauseVideo(state);
          else startVideo(state);
        };
        window.addEventListener('scroll', checkVisibility, { ...options, passive: true });
        window.addEventListener('resize', checkVisibility, options);
        checkVisibility();
      }
    });
  }

  function refresh(scope = document) {
    refreshEntrances(scope);
    refreshVideos(scope);
  }

  reduced.addEventListener('change', () => {
    if (reduced.matches) {
      finishActive();
      records.forEach(record => { if (!record.done) complete(record); });
    }
    videoStates.forEach(state => {
      if (reduced.matches) {
        state.manualPlayback = false;
        pauseVideo(state);
      } else startVideo(state);
    });
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) finishActive();
    videoStates.forEach(state => {
      if (document.hidden) pauseVideo(state);
      else startVideo(state);
    });
  });
  document.addEventListener('shopify:section:load', event => refresh(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const root = event.target;
    finishActive(root);
    records.forEach(record => {
      if (root === record.anchor || root.contains(record.anchor)) {
        entranceObserver?.unobserve(record.anchor);
        records.delete(record);
      }
    });
    videoStates.forEach(state => {
      if (!root.contains(state.video)) return;
      pauseVideo(state);
      state.controller.abort();
      videoLoadObserver?.unobserve(state.video);
      videoObserver?.unobserve(state.video);
      videoStates.delete(state);
    });
  });
  window.RollProofMotion = { refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => refresh(), { once: true });
  else refresh();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rv-pdp-photo-zoom"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rv-pdp-photo-zoom')) customElements.define('rv-pdp-photo-zoom', class extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.gallery = this.closest('rp2-gallery');
    this.dialog = this.querySelector('dialog');
    if (!this.gallery || typeof this.dialog?.showModal !== 'function') return;
    this.items = Array.from(this.gallery.querySelectorAll('[data-frame]')).filter(frame => frame.querySelector('.rv-pdp-photo-link'));
    if (!this.items.length) return;
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.viewport = this.querySelector('.rv-pdp-photo-zoom__viewport');
    this.image = this.querySelector('[data-photo-zoom-image]');
    this.caption = this.querySelector('[data-photo-zoom-caption]');
    this.counter = this.querySelector('[data-photo-zoom-count]');
    this.toggle = this.querySelector('[data-photo-zoom-toggle]');
    this.gallery.addEventListener('pointerdown', event => {
      if (this.dialog.open) return;
      this.pointerStart = { x: event.clientX, y: event.clientY };
      this.dragged = false;
    }, options);
    this.gallery.addEventListener('pointermove', event => {
      if (!this.pointerStart || this.dialog.open) return;
      if (Math.hypot(event.clientX - this.pointerStart.x, event.clientY - this.pointerStart.y) > 10) this.dragged = true;
    }, options);
    this.gallery.addEventListener('click', event => {
      const opener = event.target.closest('[data-pdp-photo-open]');
      if (!opener || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (this.dragged && event.detail > 0) { event.preventDefault(); return; }
      const index = this.items.indexOf(opener.closest('[data-frame]'));
      if (index < 0) return;
      event.preventDefault();
      this.opener = opener;
      this.showPhoto(index);
      this.savedOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.dialog.showModal();
    }, options);
    this.querySelector('[data-photo-zoom-close]').addEventListener('click', () => this.dialog.close(), options);
    this.toggle.addEventListener('click', () => this.setZoom(!this.dialog.hasAttribute('data-zoomed')), options);
    this.querySelectorAll('[data-photo-zoom-step]').forEach(button => button.addEventListener('click', () => this.showPhoto(this.current + Number(button.dataset.photoZoomStep)), options));
    this.dialog.addEventListener('keydown', event => {
      if (this.dialog.hasAttribute('data-zoomed')) return;
      const delta = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
      if (delta) { event.preventDefault(); this.showPhoto(this.current + delta); }
    }, options);
    this.dialog.addEventListener('click', event => {
      if (event.target !== this.dialog) return;
      const rect = this.dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
    }, options);
    this.dialog.addEventListener('close', () => {
      document.body.style.overflow = this.savedOverflow ?? '';
      const frame = this.items[this.current];
      const target = frame?.contains(this.opener) ? this.opener : frame?.querySelector('.rv-pdp-photo-link');
      target?.focus({ preventScroll: true });
    }, options);
  }
  showPhoto(index) {
    this.current = Math.max(0, Math.min(this.items.length - 1, index));
    const frame = this.items[this.current];
    const link = frame.querySelector('.rv-pdp-photo-link');
    this.image.src = link.href;
    this.image.alt = link.querySelector('img').alt;
    this.caption.textContent = frame.querySelector('figcaption>span')?.textContent || this.image.alt;
    this.counter.textContent = this.dataset.countTemplate.replace('[current]', this.current + 1).replace('[total]', this.items.length);
    this.querySelectorAll('[data-photo-zoom-step]').forEach(button => {
      button.disabled = Number(button.dataset.photoZoomStep) < 0 ? this.current === 0 : this.current === this.items.length - 1;
    });
    this.setZoom(false);
    const frameIndex = Array.from(this.gallery.querySelectorAll('[data-frame]')).indexOf(frame);
    if (typeof this.gallery.goTo === 'function') this.gallery.goTo(frameIndex, false);
  }
  setZoom(zoomed) {
    this.dialog.toggleAttribute('data-zoomed', zoomed);
    this.toggle.setAttribute('aria-pressed', String(zoomed));
    this.toggle.textContent = zoomed ? this.dataset.zoomOut : this.dataset.zoomIn;
    this.viewport.scrollTo({ left: 0, top: 0, behavior: 'instant' });
    if (zoomed && this.dialog.open) this.viewport.focus({ preventScroll: true });
  }
  disconnectedCallback() {
    if (this.dialog?.open) {
      this.dialog.close();
      document.body.style.overflow = this.savedOverflow ?? '';
    }
    this.controller?.abort();
    this.controller = null;
  }
});
  } catch(e) { console.error(e); }
})();

})();
